import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Row, Modal, Carousel } from 'antd';
import { MyText } from '../../components';
import { SearchContainer, SearchIcon, SearchInput, SearchButton, ButtonContainer, StyledCarousel } from './style';
import { SearchOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { fetchContentByCategoryAction } from '../../utils';

const isMobile = window.innerWidth < 768;

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div onClick={onClick} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', zIndex: 1 }}>
      <LeftOutlined style={{ fontSize: '24px' }} />
    </div>
  );
};

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div onClick={onClick} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', zIndex: 1 }}>
      <RightOutlined style={{ fontSize: '24px' }} />
    </div>
  );
};

export const MultimediaLibrary = ({ id }: { id: number }) => {
  const {t} = useTranslation("common")

  const [content, setContent] = useState<any>(null);
  const [playlists, setPlaylists] = useState<any[]>([]);
  const [multimedia, setMultimedia] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [hoveredPlaylist, setHoveredPlaylist] = useState(null);
  const contentByCategory = useSelector((state: any) => state.materials?.contentByCategory ?? { data: null, loading: false });
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchContent = async () => {
  //     if (id) {
  //       try {
  //         const fetchedContent = await fetchContentByCategory(id); 
  //         setContent(fetchedContent.ideas);
  //         setPlaylists(fetchedContent.playlists || []);
  //         setMultimedia(fetchedContent.multimedia || []);
  //       } catch (error) {
  //         console.error('Error fetching content:', error);
  //       }
  //     }
  //   };

  //   fetchContent();
  // }, [id]);
  useEffect(() => {
    if (id) dispatch(fetchContentByCategoryAction({ categoryId: id }));
  }, [id]);

  useEffect(() => {
    if (!contentByCategory.success || !contentByCategory.data) return;
    setContent(contentByCategory.data.ideas);
    setPlaylists(contentByCategory.data.playlists || []);
    setMultimedia(contentByCategory.data.multimedia || []);
  }, [contentByCategory.success, contentByCategory.data]);

  const handleVideoClick = (link: string) => {
    setSelectedVideo(link);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedVideo(null);
  };

  return (
    <Card style={{borderRadius: '20px'}}>
      <SearchContainer>
        {!isMobile && (
          <SearchIcon>
            <SearchOutlined />
          </SearchIcon>
        )}
        <SearchInput
          type="text"
          placeholder={isMobile ? `${t("search")}...` : `${t("searchByKeyword")}...`}
          value={searchTerm}
        />
        <SearchButton isMobile={isMobile}>
          {isMobile ? <SearchOutlined style={{ fontSize: '30px' }} /> : `${t("search")}`}
        </SearchButton>
      </SearchContainer>
  
      {playlists.length > 0 && playlists.map((playlist) => (
        <div key={playlist.id} style={{ margin: '32px 0' }}>
          <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
            <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito', display: 'block' }}>
              {playlist.name}
            </MyText>
          </Row>
  
          <Row >
            <Col span={24}>
            <div
          onMouseEnter={() => setHoveredPlaylist(playlist.id)}
          onMouseLeave={() => setHoveredPlaylist(null)}
        >
          {!isMobile ? (
            <StyledCarousel
            dots={false}
            slidesToScroll={2}
            slidesToShow={3}
            arrows={
              hoveredPlaylist === playlist.id &&
              multimedia.filter(item => item.playlist_id === playlist.id).length > 3
            }
          >
            {multimedia
                  .filter(item => item.playlist_id === playlist.id)
                  .map((item) => {
                    const videoId = new URL(item.link).searchParams.get('v');
                    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  
                    return (
                      <div key={item.id} style={{ padding:'0 8px' }}>
                        <div onClick={() => handleVideoClick(item.link)} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
                          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} style={{ cursor: 'pointer', transition: 'transform 0.3s ease', width: '95%' }}>
                          <div style={{
                            borderRadius: '12px',
                            background: '#fff',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}>
                            <div style={{
                              width: '100%',
                              paddingTop: '55.25%',
                              position: 'relative',
                              borderRadius: '12px',
                              overflow: 'hidden',
                            }}>
                              <img
                                src={thumbnailUrl}
                                alt={item.name}
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover'
                                }}
                              />
                            </div>
                            <div style={{
                              display: 'flex',
                              width: '100%',
                              marginTop: '24px',
                              justifyContent: 'flex-start',
                            }}>
                              <MyText color='rgba(19, 15, 38, 1)' size={22} lineHeight="28px" weight={700} style={{ fontFamily: 'Nunito' }}>
                                {item.name}
                              </MyText>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </StyledCarousel>) : (
                <>
                {multimedia
  .filter(item => item.playlist_id === playlist.id)
  .map((item) => {
    const videoId = new URL(item.link).searchParams.get('v');
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    return (
      <div key={item.id} style={{ padding: isMobile ? '0' : '0 8px' }}>
        <div onClick={() => handleVideoClick(item.link)} onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'} style={{ cursor: 'pointer', transition: 'transform 0.3s ease', width: '95%' }}>
          <div style={{
            borderRadius: '12px',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div style={{
              width: '100%',
              paddingTop: '55.25%',
              position: 'relative',
              borderRadius: '12px',
              overflow: 'hidden',
            }}>
              <img
                src={thumbnailUrl}
                alt={item.name}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>
            <div style={{
              display: 'flex',
              width: '100%',
              marginTop: '24px',
              justifyContent: 'flex-start',
            }}>
              <MyText color='rgba(19, 15, 38, 1)' size={22} lineHeight="28px" weight={700} style={{ fontFamily: 'Nunito' }}>
                {item.name}
              </MyText>
            </div>
          </div>
        </div>
      </div>
    );
  })}
                </>

              )}

              </div>
            </Col>
          </Row>
        </div>
      ))}
  
      {selectedVideo && (
        <Modal
          open={modalVisible}
          onCancel={handleModalClose}
          footer={null}
          width={isMobile ? '100%' : '50%'}
          bodyStyle={{ padding: isMobile ? 14 : 30 }}
          style={{ top: 70 }}
        >
          <div style={{ position: 'relative', paddingBottom: isMobile ? '100%' : '56.25%', height: 0 }}>
            <iframe
              title="video"
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${new URL(selectedVideo).searchParams.get('v')}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            ></iframe>
          </div>
        </Modal>
      )}
    </Card>
  );
};
